<script>

import Service from '../../services/movement-instruction';
import PlanningService from '@/services/planning';
import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';

import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';

import MovementInstructionHeader from '../../components/movement-instruction/MovementInstructionHeader.vue';
import MovementInstructionLog from '../../components/movement-instruction/MovementInstructionLog.vue';
import MovementInstructionLotMain from '../../components/movement-instruction/MovementInstructionLotMain.vue';
import MovementInstructionLotBillOfLading from '../../components/movement-instruction/MovementInstructionLotBillOfLading.vue';
import MovementInstructionLotDocuments from '../../components/movement-instruction/MovementInstructionLotDocuments.vue';
import MovementInstructionLotProductSpecs from '../../components/movement-instruction/MovementInstructionLotProductSpecs.vue';
import MovementInstructionLotMeasureUnit from '../../components/movement-instruction/MovementInstructionLotMeasureUnit.vue';
import MovementInstructionLotAnalysisSample from '../../components/movement-instruction/MovementInstructionLotAnalysisSample.vue';
// import MovementInstructionLotListDialog from '../../components/movement-instruction/MovementInstructionLotListDialog.vue';
import MovementInstructionPreviousVersion from '../../components/movement-instruction/MovementInstructionPreviousVersion.vue';
import MovementInstructionPreviousVersionForPrint from '../../components/movement-instruction/MovementInstructionPreviousVersionForPrint.vue';
import MovementInstructionCopyLot from '../../components/movement-instruction/MovementInstructionCopyLot.vue';
import MovementInstructionCloneLot from '../../components/movement-instruction/MovementInstructionCloneLot.vue';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import LabelField from '../../components/generic/LabelField.vue'
import TheoreticalLotsGrid from '@/components/planning/TheoreticalLotsGrid.vue';

import JsonUlsd from '@/common/jsonulsd.js';

export default{
    props: ['id'],
    components: {
        LabelField,
        Toolbar,
        TabView, TabPanel,
        MovementInstructionHeader, MovementInstructionLog,
        MovementInstructionLotMain, MovementInstructionLotBillOfLading, MovementInstructionLotDocuments, 
        MovementInstructionLotProductSpecs, MovementInstructionLotMeasureUnit, MovementInstructionLotAnalysisSample,
        //MovementInstructionLotListDialog,
        MovementInstructionCopyLot,
        MovementInstructionPreviousVersion, MovementInstructionCloneLot,
        MovementInstructionPreviousVersionForPrint,
        ResponsiveButton,
        TheoreticalLotsGrid
    },
    data(){
        return {
            visibilityData: {
                movementDirection: null,
                transportType: null
            },
            readOnly: true,
            statusOptions: [
                {
                    name: this.$t('DRAFT_STATUS'),
                    code: 'DRAFT'
                }
            ],
            data: {
                movementInstructionState: 'CREATED',
                lots: [],
                isClosed: false
            },
            headerData: {},
            status: 'DRAFT',
            expandedKeys: {},
            visibility: {
                headerInfo: true,
                lots: {}
            },
            copyLotDialogItem: {
                visible: false
            },
            cloneLotDialogItem:{
                visible: false
            },
            previousVersionItem: {
                visible: false
            },
            activeTab: 0,
            lotMap: {},

            disableUpdate: true,
            createFromTheoreticalLot: false,
            showTheoreticalLotLink: false,
            isTheoreticalLotLinked: false,
            theoreticalLotsDialogVisible: false,

            proposal: null,
            idRegistryProductForTheoreticalLot: null
        }
    },
    mounted(){
        this.expandedKeys = {};
        this.loadMovementInstruction();
        if(this.$route.query.startInEdit){
            this.readOnly = false;
        }
        if(this.$route.query.fromTheoreticalLot){
            this.createFromTheoreticalLot = true;
        }
        //this.proposal = JsonUlsd.ulsd();
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        loadVesselNominationProposal(){
            Service.getVesselNominationDelta(this.data.voyageNumber, response => {
                if(response.success){
                    this.proposal = response.data;

                    if(this.proposal.parcels && this.proposal.parcels.length > 0){
                        for(let i=0; i< this.proposal.parcels.length; i++){
                            let parcel = this.proposal.parcels[i];
                            
                            if(parcel.cpDate){
                                parcel.charterPartyDated = parcel.cpDate;
                            }
                        }
                    }

                    if(this.data.lots && this.data.lots.length > 0){
                        for(let i=0; i< this.data.lots.length; i++){
                            let lot = this.data.lots[i];
                            let parcel = this.extractLotProposal(lot.lotCode);
                            if(parcel){
                                lot.parcel = parcel.name;
                            }else{
                                lot.parcel = null;
                            }
                        }
                    }
                }
            });
        },
        loadMovementInstruction(lastLotActive, withTheoreticalLot){
            if(this.id != 0){
                this.checkTheoreticalLot();

                Service.getSummary(this.id, response => {
                    if(response.success){
                        this.data = response.data;

                        this.visibilityData.transportType = this.data.transportType;
                        this.visibilityData.movementDirection = this.data.movementDirection;
                        this.$store.dispatch('security/setNavbarTitle', response.data.voyageNumber);

                        this.$refs.lotHeaderTab.loadHeader();
                        if(this.createFromTheoreticalLot){
                            this.createFromTheoreticalLot = false;
                            let theoreticalLotData = this.$store.getters['movementInstruction/getTheoreticalLotData'](this.id);
                            if(theoreticalLotData){
                                this.edit(true);
                            }
                        }
                        if(lastLotActive){
                            this.activeTab = this.data.lots.length;
                        }

                        this.loadVesselNominationProposal()

                        Service.getUserRoleOperationTypeCombo((response) => {
                            if(response.success){
                                let operationTypes = response.data;
                                let found = operationTypes.find(({value}) => value === this.data.idOperationType);
                                this.disableUpdate = found ? false: true;
                            }
                        })

                    }
                });
            }else{
                this.readOnly = false;
                this.$store.dispatch('security/setNavbarTitle', 'movementInstructions.new');
            }
        },
        checkTheoreticalLot(){
            this.showTheoreticalLotLink = false;
            this.isTheoreticalLotLinked = false;
            PlanningService.checkMovementInstruction(this.id, (response) => {
                if(response.success){
                    this.showTheoreticalLotLink = true;
                    this.isTheoreticalLotLinked = response.data;
                }
            })
        },
        checkMovementInstructionToBeAssociated(){
            PlanningService.checkMovementInstructionToBeAssociated(this.id, (response) => {
                if(response.success && response.data){
                    this.$confirm.require({
                        message: this.$t('messages.movementInstructionNotAssociatedMessage'),
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: this.$t('yes'),
                        rejectLabel: this.$t('no'),
                        accept: () => {
                            this.theoreticalLotsDialogVisible = true;
                            if(this.data && this.data.lots && this.data.lots.length > 0){
                                this.idRegistryProductForTheoreticalLot = this.data.lots[0].idRegistryProduct;
                            }
                        },
                        reject: () => {
                            //callback to execute when user rejects the action
                            this.$confirm.close();
                        }
                    });
                }
            })
        },
        loadMovementInstructionLots(){
            let filters = [];
            let f = {
                operator: 'eq',
                value: this.data.id,
                property: 'IdMovementInstructionHeader'
            }
            filters.push(f);

            filters.push({
                operator: 'eq',
                value: false,
                property: 'IsDeleted'
            })

            let params = {
                filter: JSON.stringify(filters),
            }

            Service.getLots(params, response => {
                this.data.lots = response.data.data;
                this.data.lots.forEach((lot) => {
                    lot.contractDate =  Utils.dateToCurrentTimeZone(lot.contractDate);
                });
            });
        },
        save(){
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        },
        edit(withTheoreticalLot){
            this.$store.dispatch("generic/setLoading", true);
            Service.startEdit(this.data, 
                response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        if(withTheoreticalLot){
                            this.addLotFromTheoreticalLot();
                        }else{
                            this.loadMovementInstruction();
                        }
                        this.readOnly = false;
                        this.$refs.lotHeaderTab.loadHeader();
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                } 
            );


            // this.readOnly = false;
        },

        editAdmin(){
            this.readOnly = false;
        },
        restorePrevVersion(){
            
            this.$refs.previousVersionDialog.loadData();
            this.$refs.previousVersionDialog.show();


        },
        openPrevVersionForPrint(){
            this.$refs.previousVersionDialogForPrint.loadData();
            this.$refs.previousVersionDialogForPrint.show();
        },
        addLot(){

            let newLot = {
                lotCode: this.data.voyageNumber + '-' + 'NEW',
                defaultData: {
                    quantityUoMCode: 'MT'
                }
                // idPortOrLocationOfLoading
                // idPortOrLocationOfDischarge
            };

            let res = this.$store.state.masterData['plants'].filter((item) => {
                return item.value == this.headerData.idPlant;
            });
            if(res && res.length > 0){
                let selectedPlant = res[0];

                if(this.visibilityData.movementDirection == CommonConstants.movementDirection.OUT){
                    newLot.defaultData.idPortOrLocationOfLoading = selectedPlant.extraData.portId;
                    newLot.defaultData.idPlaceOfLoading = selectedPlant.extraData.idPlaceOfLoadingDischarge;
                    newLot.defaultData.idOriginCountry = selectedPlant.extraData.idOriginDestinationCountry;
                }else if(this.visibilityData.movementDirection == CommonConstants.movementDirection.IN){
                    newLot.defaultData.idPortOrLocationOfDischarge = selectedPlant.extraData.portId;
                    newLot.defaultData.idPlaceOfDischarge = selectedPlant.extraData.idPlaceOfLoadingDischarge;
                    newLot.defaultData.idDestinationCountry = selectedPlant.extraData.idOriginDestinationCountry;
                    //newLot.defaultData.idDestinationTaxWarehouse = selectedPlant.extraData.idTaxWarehouse;
                }
            }

            this.data.lots.push(newLot);
            this.activeTab = this.data.lots.length;
        },
        addLotFromTheoreticalLot(){
            let theoreticalLotData = this.$store.getters['movementInstruction/getTheoreticalLotData'](this.id);
            if(theoreticalLotData){
                let newLot = {
                    lotCode: this.data.voyageNumber + '-' + 'NEW',
                    defaultData: {
                        quantityUoMCode: 'MT',
                        quantity: theoreticalLotData.plannedQuantity,
                        minimumQuantity: theoreticalLotData.plannedMinimumQuantity,
                        maximumQuantity: theoreticalLotData.plannedMaximumQuantity,
                        idRegistryProduct: theoreticalLotData.plannedIdRegistryProduct
                    }
                    // idPortOrLocationOfLoading
                    // idPortOrLocationOfDischarge
                };

                let res = this.$store.state.masterData['plants'].filter((item) => {
                    return item.value == this.headerData.idPlant;
                });
                if(res && res.length > 0){
                    let selectedPlant = res[0];

                    if(this.visibilityData.movementDirection == CommonConstants.movementDirection.OUT){
                        newLot.defaultData.idPortOrLocationOfLoading = selectedPlant.extraData.portId;
                        newLot.defaultData.idPlaceOfLoading = selectedPlant.extraData.idPlaceOfLoadingDischarge;
                        newLot.defaultData.idOriginCountry = selectedPlant.extraData.idOriginDestinationCountry;
                    }else if(this.visibilityData.movementDirection == CommonConstants.movementDirection.IN){
                        newLot.defaultData.idPortOrLocationOfDischarge = selectedPlant.extraData.portId;
                        newLot.defaultData.idPlaceOfDischarge = selectedPlant.extraData.idPlaceOfLoadingDischarge;
                        newLot.defaultData.idDestinationCountry = selectedPlant.extraData.idOriginDestinationCountry;
                        //newLot.defaultData.idDestinationTaxWarehouse = selectedPlant.extraData.idTaxWarehouse;
                    }
                }
                this.data.lots.push(newLot);
                this.activeTab = this.data.lots.length;
                this.$store.dispatch("movementInstruction/resetTheoreticalLot", {});
            }
        },
        setReadOnly(){
            this.readOnly = true;
        },
        deleteMovementInstruction(){
            this.$confirm.require({
                message: this.$t('messages.delete_current_movement_instruction'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    this.$store.dispatch("generic/setLoading", true);
                    Service.deleteMovementInstruction(this.id, 
                        response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.loadMovementInstruction();
                                this.$confirm.close();
                            }
                            else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                    )
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        cloneLot(lotId){

             this.$confirm.require({
                message: this.$t('messages.clone_current_lot'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    let body = {
                        movementInstructionHeaderId: this.id,
                        lotId: lotId
                    }

                    Service.cloneLot(body, 
                        response => {
                            if(response.success){
                                this.setReadOnly();
                                this.loadMovementInstruction(true);
                                this.$confirm.close();
                            }
                            else{
                                this.$toast.add({detail: response.message && response.message != '' ? this.$t(response.message) :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                    )
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });

            // this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        },
        deleteLot(lotId){
            this.$confirm.require({
                message: this.$t('messages.delete_current_lot'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    this.$store.dispatch("generic/setLoading", true);
                    Service.deleteLot(lotId, 
                        response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.loadMovementInstruction();
                                this.$confirm.close();
                            }
                            else{
                                this.$toast.add({detail: response.message && response.message != '' ? this.$t(response.message) :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                    )
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        openNote(){
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        },
        hideAllSections(){
            this.visibility.headerInfo = false;
            for(var key in this.visibility.lots){
                for(var subKey in this.visibility.lots[key]){
                    this.visibility.lots[key][subKey] = false;
                }
            }
        },
        showSection(lotId, section){
            this.hideAllSections();
            this.visibility.lots[lotId].tabView = true;
            this.visibility.lots[lotId][section] = true;
        },
        goBack(){
            this.$router.push('/movement-instruction');
        },
        showHeaderInfo(){
            this.hideAllSections();
            this.visibility.headerInfo = true;
        },
        showLotInfo(lot){
            this.hideAllSections();
            this.showSection(lot.id, 'main');
        },
        onPlantChange(el){
            
            let lotMainTabs = this.$refs.lotMainTab;
            if(lotMainTabs){
                lotMainTabs.forEach((tab) => {
                    if(this.visibilityData.movementDirection == CommonConstants.movementDirection.OUT){
                        tab.data.idPortOrLocationOfLoading = el.extraData.portId;
                        tab.data.idPlaceOfLoading = el.extraData.idPlaceOfLoadingDischarge;
                        tab.data.idOriginCountry = el.extraData.idOriginDestinationCountry;
                    }else if(this.visibilityData.movementDirection == CommonConstants.movementDirection.IN){
                        tab.data.idPortOrLocationOfDischarge = el.extraData.portId;
                        tab.data.idPlaceOfDischarge = el.extraData.idPlaceOfLoadingDischarge;
                        tab.data.idDestinationCountry = el.extraData.idOriginDestinationCountry;
                        //tab.data.idDestinationTaxWarehouse = el.extraData.idTaxWarehouse;
                    }

                })
            }
        },
        openCopyLot(lotId, section){

            this.$refs.lotListDialog.populate(lotId, section);
            this.$refs.lotListDialog.show();
            
        },
        copyLot(body){

            Service.copyLot(body, 
                response => {
                    if(response.success){
                        this.visible=false;
                        let components = this.$refs[body.type];
                            components.forEach((comp) => {
                                if(comp.id == body.destinationLotId){
                                    comp.reload();
                                }
                            })

                        //this.copyLotFn(this.lotId, this.section);
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('movementInstructions.copyLotSuccessMessage'), life: 3000});
                        this.$refs.lotListDialog.hide();
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            );
            
        },
        printPdf(){
            let params = {
                movementInstructionCode: this.headerData.code
            };
            this.$store.dispatch("generic/setLoading", true);
            Service.printMovementInstruction(params, response => {
                
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', this.headerData.voyageNumber + '-' + this.headerData.code + '.pdf');
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        openCloneLot(){ 
            this.$refs.cloneLotDialog.searchData();
            this.$refs.cloneLotDialog.show();
        },
        submitCloneLot(body){
            this.$store.dispatch("generic/setLoading", true);
            Service.cloneLot(body, 
                response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.setReadOnly();
                        this.loadMovementInstruction(true);
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('movementInstructions.messages.lotClonedSuccess'), life: 3000});
                        this.$refs.cloneLotDialog.hide();
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? this.$t(response.message) :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            )
        },
        updateVisibilityData(field, value){
            this.visibilityData[field] = value;
        },
        updateHeaderData(field, value){
            this.headerData[field] = value;
        },
        updateLotDetail(idLot, field, value){

            if(!this.lotMap[idLot]){
                this.lotMap[idLot] = {};
            }
            this.lotMap[idLot][field] = value;
        },
        openLinkTheoreticalLot(){
            this.theoreticalLotsDialogVisible = true;
        },
        linkTheoreticalLot(theoreticalLotId){
            let linkDto = {
                idTheoreticalLot: theoreticalLotId,
                idMovementInstructionHeader: this.id
            }
            PlanningService.linkMovementInstruction(linkDto, 
                response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.theoreticalLotsDialogVisible = false;
                        this.checkTheoreticalLot();
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            )
        },
        unlinkTheoreticalLot(){
            this.$confirm.require({
                message: this.$t('messages.movementInstructionUnlinkTheoreticalLot'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    PlanningService.unlinkMovementInstruction({id: this.id}, (response) => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.theoreticalLotsDialogVisible = false;
                            this.checkTheoreticalLot();
                        }
                        else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        extractLotProposal(lotCode){
            if(this.proposal && this.proposal.parcels && this.proposal.parcels.length > 0){
                return this.proposal.parcels.find(x => x.movementInstructionLotCode == lotCode);
            }
            return null;
        },
        saveLotParcel(lot){
            let body = {
                topicId: this.proposal.topicId,
                parcelName: lot.parcel,
                movementInstructionLotCode: lot.lotCode
            };

            Service.vesselNominationParcelLink(body, response => {
                if(response.success){
                    this.loadVesselNominationProposal();
                }
                else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        }
    }
}

</script>


<template>
  <main>
    
        <Dialog v-model:visible="theoreticalLotsDialogVisible" modal :style="{ width: '85vw'}">
            <TheoreticalLotsGrid ref="theoreticalLotsGrid" :showCreate="false" :showLink="true" :idMovementInstructionHeader="id" :startDate="headerData.laycanStartDate" @link-theoretical-lot="linkTheoreticalLot" :idRegistryProduct="idRegistryProductForTheoreticalLot"/>
        </Dialog>
        <!-- <MovementInstructionLotListDialog ref="lotListDialog" :item="copyLotDialogItem" :lots="data.lots" :copyLotFn="copyLot"/> -->
        <MovementInstructionCopyLot ref="lotListDialog" :item="copyLotDialogItem" :lots="data.lots" :submitFn="copyLot"/>
        <MovementInstructionPreviousVersion ref="previousVersionDialog" :item="previousVersionItem" :idMovementInstructionHeader="id" :reloadMovementInstruction="loadMovementInstruction"/>
        <MovementInstructionPreviousVersionForPrint ref="previousVersionDialogForPrint" :idMovementInstructionHeader="id" />
        <MovementInstructionCloneLot ref="cloneLotDialog" :item="cloneLotDialogItem" :idMovementInstructionHeader="id" :reloadMovementInstruction="loadMovementInstruction" :summary="data" :submitFn="submitCloneLot"/>
      <div>
        <Toolbar>
            <template #start>
                <ResponsiveButton :label="$t('btn.back')" icon="pi pi-arrow-left" class="p-button-info mr-2" @click="goBack" />
                <ResponsiveButton :label="$t('btn.edit')" icon="pi pi-pencil" class="p-button-success mr-2" @click="edit" :disabled="disableUpdate || !uiPermissions('movementInstructionEditButton').isEnabled || !readOnly || data.isClosed" v-if="!uiPermissions('movementInstructionEdit').isHidden"/>
                <ResponsiveButton :label="$t('movementInstructions.btn.restorePrevVersion')" icon="pi pi-replay" class="p-button-info mr-2" @click="restorePrevVersion" :disabled="disableUpdate || !uiPermissions('movementInstructionRestorePrevVersionButton').isEnabled || id == 0 || !readOnly || data.isClosed" v-if="!uiPermissions('movementInstructionRestorePrevVersionButton').isHidden"/>
                <ResponsiveButton :label="$t('movementInstructions.btn.prevVersion')" icon="pi pi-history" class="p-button-info mr-2" @click="openPrevVersionForPrint" :disabled="id == 0" />
                <ResponsiveButton :label="$t('movementInstructions.btn.addLot')" icon="pi pi-plus" class="p-button-success mr-2" @click="addLot" :disabled="disableUpdate || !uiPermissions('movementInstructionAddLotButton').isEnabled || id == 0 || readOnly || data.isClosed" v-if="!uiPermissions('movementInstructionAddLotButton').isHidden"/>
                <ResponsiveButton :label="$t('movementInstructions.btn.cloneLot')" icon="pi pi-clone" class="p-button-success mr-2" @click="openCloneLot" :disabled="disableUpdate|| !uiPermissions('movementInstructionCloneLotButton').isEnabled || readOnly || data.isClosed" v-if="!uiPermissions('movementInstructionCloneLotButton').isHidden"/>
                <ResponsiveButton :label="$t('movementInstructions.btn.deleteInstruction')" icon="pi pi-trash" class="p-button-danger mr-2" @click="deleteMovementInstruction" :disabled="disableUpdate || !uiPermissions('movementInstructionDeleteButton').isEnabled || id == 0 || data.isClosed" v-if="!uiPermissions('movementInstructionDeleteButton').isHidden"/>
                <ResponsiveButton :label="$t('btn.print')" icon="pi pi-file-pdf" class="p-button-info mr-2" @click="printPdf" :disabled="!uiPermissions('MovementInstruction.Report').isEnabled ||   id == 0"/>
                <ResponsiveButton :label="$t('btn.admin')" icon="pi pi-pencil" class="p-button-success mr-2" @click="editAdmin" :disabled="disableUpdate || !uiPermissions('movementInstructionAdminEditButton').isEnabled || !readOnly || data.isClosed" v-if="!uiPermissions('movementInstructionAdminEditButton').isHidden"/>
            </template>

            <template #end>
                <LabelField :value="data.movementInstructionState ? $t(data.movementInstructionState) : null" :label="$t('status')"/>
                <ResponsiveButton :label="$t('btn.theoreticalLots')" icon="fa-solid fa-link" v-if="showTheoreticalLotLink && uiPermissions('theoreticalLotsAddMovementInstructionsButton').isEnabled" 
                    @click="openLinkTheoreticalLot" class="p-button-sm m-2" />
                <ResponsiveButton :label="$t('btn.unlinkTheoreticalLot')" icon="fa-solid fa-link-slash" v-if="isTheoreticalLotLinked && uiPermissions('theoreticalLotsAddMovementInstructionsButton').isEnabled" 
                    @click="unlinkTheoreticalLot" class="p-button-sm m-2" />
            </template>
        </Toolbar>
        <div class="grid">
            <div class="col-12">
                <TabView v-model:activeIndex="activeTab">
                    <TabPanel>
                        <template #header>
                            <span>{{$t('movementInstructions.headerInfo')}}</span>
                            <Tag class="ml-2" icon="pi pi-exclamation-triangle" severity="warning" v-tooltip="$t('VesselNomination.modifiedFieldListNotEmpty')" 
                            v-if="proposal && proposal.modifiedFieldList && proposal.modifiedFieldList.length > 0"/>
                            <Tag class="ml-2" icon="pi pi-exclamation-triangle" severity="warning" v-tooltip="$t('VesselNomination.lotsCountDifferent')" 
                            v-if="proposal && proposal.parcels && data.lots && proposal.parcels.length != data.lots.length"/>
                        </template>
                        <MovementInstructionHeader :readOnly="readOnly" :id="id" :visibilityData="visibilityData" ref="lotHeaderTab" @update-visibility-data="updateVisibilityData" @update-header-data="updateHeaderData"
						:onPlantChange="onPlantChange" :lots="data.lots" :proposal="proposal" @check-movement-instruction-to-be-associated="checkMovementInstructionToBeAssociated" />
                    </TabPanel>
                    <TabPanel v-for="lot in data.lots" :key="'LOT_' + lot.id">
                        <template #header>
                            <span>{{lot.lotCode}}</span> 
                            <Tag class="ml-2" icon="pi pi-exclamation-triangle" severity="warning" v-tooltip="$t('VesselNomination.modifiedFieldListNotEmpty')" 
                            v-if="proposal && ((proposal.modifiedFieldList && proposal.modifiedFieldList.includes('incoterm')) || (extractLotProposal(lot.lotCode) && extractLotProposal(lot.lotCode).modifiedFieldList && extractLotProposal(lot.lotCode).modifiedFieldList.length > 0))"
                            />
                        </template>
                        <Toolbar>
                            <template #start v-if="proposal && !readOnly">
                                <Dropdown v-model="lot.parcel" :options="proposal.parcels" optionLabel="name" optionValue="name" class="w-full md:w-14rem" />
                                <ResponsiveButton :label="$t('movementInstructions.btn.saveVesselNominationNewParcelLink')" icon="pi pi-save" class="p-button-outlined p-button-sm" @click="saveLotParcel(lot)" :disabled="!uiPermissions('movementInstructionDuplicateLotButton').isEnabled || !lot.id || readOnly" v-if="!uiPermissions('movementInstructionDuplicateLotButton').isHidden && !readOnly" />
                            </template>
                            <template #end>
                                <ResponsiveButton :label="$t('movementInstructions.btn.duplicateLot')" icon="pi pi-clone" class="p-button-outlined p-button-sm" @click="cloneLot(lot.id)" :disabled="!uiPermissions('movementInstructionDuplicateLotButton').isEnabled || !lot.id || readOnly" v-if="!uiPermissions('movementInstructionDuplicateLotButton').isHidden && !readOnly" />
                                <ResponsiveButton :label="$t('movementInstructions.btn.deleteLot')" icon="pi pi-trash" class="p-button-outlined p-button-sm" @click="deleteLot(lot.id)" :disabled="!uiPermissions('movementInstructionDeleteLotButton').isEnabled || !lot.id || readOnly" v-if="!uiPermissions('movementInstructionDeleteLotButton').isHidden && !readOnly" />
                            </template>
                        </Toolbar>
                        <TabView>
                            <TabPanel :header="$t('movementInstructions.lotMainInfo')" >
                                <MovementInstructionLotMain 
                                ref="lotMainTab"
                                :readOnly="readOnly" :id="lot.id" :movementInstructionId="id" :refreshLots="loadMovementInstruction" :visibilityData="visibilityData" :headerData="headerData" :defaultData="lot.defaultData"
                                @update-lot-detail="updateLotDetail"
                                @set-read-only="setReadOnly"
								:proposal="proposal" @check-movement-instruction-to-be-associated="checkMovementInstructionToBeAssociated"
                                />
                            </TabPanel>
                            <TabPanel :header="$t('movementInstructions.billOfLading')" 
                                v-if="lot.id != null && (visibilityData.transportType != constants.transportType.STOCK_TRANSFER) && (visibilityData.movementDirection == constants.movementDirection.IN && visibilityData.transportType == constants.transportType.SHIP)">
                                <Toolbar v-if="!readOnly">
                                    <template #end>
                                        <ResponsiveButton :label="$t('movementInstructions.btn.copyLot')" icon="pi pi-copy" class="p-button-outlined p-button-sm" @click="openCopyLot(lot.id, 'MovementInstructionLotBillOfLadingHeader')" :disabled="!uiPermissions('movementInstructionCopyLotButton').isEnabled || !lot.id || readOnly" v-if="!uiPermissions('movementInstructionCopyLotButton').isHidden && !readOnly" />
                                    </template>
                                </Toolbar>
                                <MovementInstructionLotBillOfLading :readOnly="readOnly" :id="lot.id" ref="MovementInstructionLotBillOfLadingHeader"/>
                            </TabPanel>
                            <TabPanel :header="$t('movementInstructions.documents')" v-if="lot.id != null && (visibilityData.transportType != constants.transportType.STOCK_TRANSFER)">
                                <Toolbar v-if="!readOnly">
                                    <template #end>
                                        <ResponsiveButton :label="$t('movementInstructions.btn.copyLot')" icon="pi pi-copy" class="p-button-outlined p-button-sm" @click="openCopyLot(lot.id, 'MovementInstructionLotDocument')" :disabled="!uiPermissions('movementInstructionCopyLotButton').isEnabled || !lot.id || readOnly" v-if="!uiPermissions('movementInstructionCopyLotButton').isHidden && !readOnly" />
                                    </template>
                                </Toolbar>
                                <MovementInstructionLotDocuments :readOnly="readOnly" :id="lot.id" ref="MovementInstructionLotDocument" :proposal="proposal" :lotCode="lot.lotCode"/>
                            </TabPanel>
                            <TabPanel :header="$t('movementInstructions.productSpecifications')" v-if="lot.id != null && (visibilityData.transportType != constants.transportType.STOCK_TRANSFER)">
                                <MovementInstructionLotProductSpecs :readOnly="readOnly" :id="lot.id" ref="MovementInstructionLotProductSpecification" :lotDetails="lotMap[lot.id]" :headerData="headerData" />
                            </TabPanel>
                            <TabPanel :header="$t('movementInstructions.measureUnits')" v-if="lot.id != null && (visibilityData.transportType != constants.transportType.STOCK_TRANSFER)">
                                <Toolbar v-if="!readOnly">
                                    <template #end>
                                        <ResponsiveButton :label="$t('movementInstructions.btn.copyLot')" icon="pi pi-copy" class="p-button-outlined p-button-sm" @click="openCopyLot(lot.id, 'MovementInstructionLotUoM')" :disabled="!uiPermissions('movementInstructionCopyLotButton').isEnabled || !lot.id || readOnly" v-if="!uiPermissions('movementInstructionCopyLotButton').isHidden && !readOnly" />
                                    </template>
                                </Toolbar>
                                <MovementInstructionLotMeasureUnit :readOnly="readOnly" :id="lot.id" ref="MovementInstructionLotUoM" :proposal="proposal" :lotCode="lot.lotCode"/>
                            </TabPanel>
                            <TabPanel :header="$t('movementInstructions.analysisSamples')" v-if="lot.id != null && (visibilityData.movementDirection == constants.movementDirection.OUT && (visibilityData.transportType == constants.transportType.SHIP || visibilityData.transportType == constants.transportType.PIPE))">
                                <Toolbar v-if="!readOnly">
                                    <template #end>
                                        <ResponsiveButton :label="$t('movementInstructions.btn.copyLot')" icon="pi pi-copy" class="p-button-outlined p-button-sm" @click="openCopyLot(lot.id, 'MovementInstructionLotAnalysisSample')" :disabled="!uiPermissions('movementInstructionCopyLotButton').isEnabled || !lot.id || readOnly" v-if="!uiPermissions('movementInstructionCopyLotButton').isHidden && !readOnly" />
                                    </template>
                                </Toolbar>
                                <MovementInstructionLotAnalysisSample :readOnly="readOnly" :id="lot.id" ref="MovementInstructionLotAnalysisSample"/>
                            </TabPanel>
                        </TabView>
                    </TabPanel>
                    <TabPanel>
                        <template #header>
                            <span>{{$t('movementInstructions.log')}}</span>
                        </template>
                        <MovementInstructionLog :id="id"/>
                    </TabPanel>
                </TabView>
            </div>
        </div>
      </div>
  </main>
</template>
